import React from 'react';

export interface DetailGridItem {
  label: string;
  value: React.ReactNode;
}

export interface DetailGridProps {
  items: DetailGridItem[];
  className?: string;
}

const DetailGrid: React.FC<DetailGridProps> = ({ items, className = '' }) => (
  <dl className={`grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 ${className}`}>
    {items.map((item) => (
      <div key={item.label} className="rounded-xl border border-monday-border-light bg-white/70 p-3">
        <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-monday-text-muted">
          {item.label}
        </dt>
        <dd className="mt-1 text-sm font-semibold text-monday-text">
          {item.value}
        </dd>
      </div>
    ))}
  </dl>
);

export default DetailGrid;
